import { ComponentPropsWithoutRef } from 'react';

export const DownloadIconV3 = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 32 32">
      <path
        d="M20.71 17.29a1 1 0 0 1 0 1.42l-4 4a1 1 0 0 1-1.42 0l-4-4a1 1 0 0 1 1.42-1.42l2.29 2.3V12a1 1 0 0 1 2 0v7.59l2.29-2.3a1 1 0 0 1 1.42 0zM27 9.72V27a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h12.06a3 3 0 0 1 2.31 1.08L26.3 7.8a3 3 0 0 1 .7 1.92zm-6-5.16V7a1 1 0 0 0 1 1h1.86zM25 10h-3a3 3 0 0 1-3-3V4H8a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1z"
        data-original="#000000"
      />
    </svg>
  );
};
